/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerFindActivitiesQueryResponse, TasksControllerFindActivitiesPathParams, TasksControllerFindActivitiesQueryParams, TasksControllerFindActivities401, TasksControllerFindActivities403 } from "../../models/tasksController/TasksControllerFindActivities";

function getTasksControllerFindActivitiesUrl(id: TasksControllerFindActivitiesPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/tasks/${id}/activities` as const }  
  return res
}

/**
 * @summary Curated activity history for a task
 * {@link /api/v1/tasks/:id/activities}
 */
export async function tasksControllerFindActivities(id: TasksControllerFindActivitiesPathParams["id"], params?: TasksControllerFindActivitiesQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TasksControllerFindActivitiesQueryResponse, ResponseErrorConfig<TasksControllerFindActivities401 | TasksControllerFindActivities403>, unknown>({ method : "GET", url : getTasksControllerFindActivitiesUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}